import { createStore } from 'zustand'
import { createContext } from 'react'
// import { getMyStoreValue, useMyStore } from '@/hooks/useMyStore';
// import { DEFAULT_COORDS } from '@/constants';

export const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export const DEFAULT_COORDS = {
  latitude: 28.538336,
  longitude: -81.379234,
}

export const createStoreLocatorContext = initProps => {
  const DEFAULT_PROPS = {
    myStore: null,
    selectedStore: null,
    currentPosition: {
      lat: DEFAULT_COORDS.latitude,
      lng: DEFAULT_COORDS.longitude,
    },
    searchedLocation: '',
  }
  return createStore(set => ({
    ...DEFAULT_PROPS,
    ...initProps,
    setMyStore: myStore => set(() => ({ myStore })),
    setStores: stores => set(() => ({ stores })),
    setCurrentPosition: currentPosition => set(() => ({ currentPosition })),
    setCurrentPositionMarker: currentPositionMarker => set(() => ({ currentPositionMarker })),
    selectStore: storeNumber =>
      set(state => {
        const index = state.stores.findIndex(store => store.storeNumber === storeNumber)
        // if (index === -1) {
        //   const myStore = getMyStoreValue()
        //   return { selectedStore: myStore }
        // }
        return { selectedStore: state.stores[index] }
      }),
    setMapInstance: mapInstance => set(() => ({ mapInstance })),
    setMarkers: (marker, storeId, letter) =>
      set(state => ({
        markers: { ...state.markers, [storeId]: { instance: marker, letter } },
      })),
    clearMarkers: () => set(() => ({ markers: {} })),
    setSearchedLocation: searchedLocation => set(() => ({ searchedLocation })),
  }))
}

export const StoreLocatorContext = createContext(null)
